<script>
import { defineComponent } from 'vue';
import sdButton from '@smartdesign/vue/components/button';

export default defineComponent({
  extends: sdButton,
  methods: {
    emit: () => {}, // do not emit duplicate click event
  },
});
</script>
